// extracted by mini-css-extract-plugin
export default {"meals":"available_meals__SbIP9","meals-appear":"available_meals-appear__bgaaw","loadingSection":"available_loadingSection__uLUtu","mealsError":"available_mealsError__6qq5q"};